import { Box, Container, Divider, Drawer, List, ListItem, ListItemButton, ListItemIcon, Toolbar, Typography } from "@mui/material";
import Navigation from "../../components/general/Navigation";

import RouterDashboard from "../../Router/RoutesDashboard";
import ListItemText from '@mui/material/ListItemText';
import React, { useEffect, useState } from "react";
import { Route, Routes } from "react-router-dom";
import { makeStyles } from '@mui/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Link } from "react-router-dom";
import packageJson from '../../../package.json';

interface Props {
    window?: () => Window;
}

const useStyles = makeStyles({
    selectedListItem: {
        color: '#505050', boxSizing: "border-box", minHeight: 30,
        "&.Mui-selected": {
            background: "linear-gradient(90deg, rgba(244,245,250,1) 0%, #233878 90%);",
            color: '#FFFFFF',
            fontWeight: 'bold',
            ":hover": {
                backgroundColor: "#ebf0fe"
            }
        }
        ,
        ":hover": {
            backgroundColor: "#ebf0fe"
        }
    },
});
const drawerWidth = 230;

function Dashboard(props: Props) {
    const logoEducem = "https://resoures-educem.s3.us-west-2.amazonaws.com/Logos/Educem/500500cb.png";
    const classes = useStyles();
    const { window } = props;
    const [selectedIndex, setSelectedIndex] = useState('home');
    const [mobileOpen, setMobileOpen] = useState(false);
    const router = RouterDashboard();
    const handleDrawerToggle = () => { setMobileOpen(!mobileOpen); };

    const handleListItemClick = (event: any, index: string, title: string) => {
        setSelectedIndex(index);
        sessionStorage.setItem('item', index);
        document.title = title;
        sessionStorage.setItem('title', title);
    };

    useEffect(() => {
        if (!sessionStorage.getItem('item')) {
            sessionStorage.setItem('item', 'home');
        }

        if (!sessionStorage.getItem('title')) {
            sessionStorage.setItem('title', 'CMS Menah - Inicio');
            document.title = 'CMS Menah - Inicio';
        }
    }, [])

    const drawer = (
        <div style={{ position: 'relative', minHeight: '100%' }}>
            <Toolbar className="star-bu" sx={{ display: "flex", alignItems: "center", justifyContent: "center", px: [1], m: 0 }} >
                <img src={logoEducem} alt="Logo" width={120} style={{ marginTop: 5 }} />
            </Toolbar>
            <List sx={{ mt: 2 }}>
                {router ? router.map((module: any, idx: any) => (
                    <span key={idx}>
                        <Divider key={idx} className="star-burst" textAlign='left' sx={{ color: "#B9B7B7", fontSize: 12 }}>
                            <p style={{ color: 'black', margin: 0 }}>{module.section}</p></Divider>
                        {module.screens!.map((item: any, id: any) => {
                            if (item.name) {
                                return (
                                    <ListItem className={item.id} key={id} disablePadding>
                                        <ListItemButton sx={{ borderRadius: "0 25px 25px 0", paddingLeft: 5 }} className={classes.selectedListItem} component={Link} to={item?.url}
                                            selected={sessionStorage.getItem('item') === item.id} onClick={(event) => handleListItemClick(event, item.id, item.title)}>
                                            <ListItemIcon sx={{ minWidth: 40 }}>
                                                <span className="material-icons" style={{ color: '#4D4C4C' }} >{item.icon}</span>
                                            </ListItemIcon>
                                            <ListItemText primary={item.name} />
                                        </ListItemButton>
                                    </ListItem>
                                );
                            } return null;
                        })
                        }
                    </span>
                )) : null
                }
            </List>
            <Box sx={{ position: 'absolute', bottom: 0, left: 0, right: 0, p: 2, textAlign: 'center' }}>
                <Typography variant="caption" sx={{ color: '#4E4E4E', fontSize: '0.75rem' }}>
                    v{packageJson.version}
                </Typography>
            </Box>
        </div>
    );

    const container = window !== undefined ? () => window().document.body : undefined;

    return (
        <Box className={'cuerpo'} sx={{ display: 'flex' }}>
            <CssBaseline />
            <Navigation drawerWidth={drawerWidth} handleDrawerToggle={handleDrawerToggle} />
            <Box
                component="nav"
                sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}
                aria-label="mailbox folders"
            >
                <Drawer
                    container={container}
                    variant="temporary"
                    open={mobileOpen}
                    onClose={handleDrawerToggle}
                    ModalProps={{
                        keepMounted: true,
                    }}
                    sx={{
                        display: { xs: 'block', sm: 'none' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, backgroundColor: '#f4f5fa' },
                    }}
                >
                    {drawer}
                </Drawer>
                <Drawer
                    variant="permanent"
                    sx={{
                        display: { xs: 'none', sm: 'block' },
                        '& .MuiDrawer-paper': { boxSizing: 'border-box', width: drawerWidth, backgroundColor: '#f4f5fa', color: '#4E4E4E', border: 'none' },
                    }}
                    open
                >
                    {drawer}
                </Drawer>
            </Box>
            <Box
                component="main"
                sx={{ flexGrow: 1, p: 2, width: { sm: `calc(100% - ${drawerWidth}px)`, backgroundColor: '#f4f5fa' }, height: "100vh", overflow: "auto" }}
            >
                <Toolbar />
                <Container maxWidth="xl" sx={{ mt: 1, mb: 1 }}>
                    <React.Suspense fallback={""}>
                        <Routes>
                            {
                                router.map((route: any) => (
                                    route.screens.map((item: any, idx: any) => {
                                        return (
                                            <Route key={`component${idx}`} path={item?.url} element={<item.component />} />
                                        );
                                    })
                                ))
                            }
                        </Routes>
                    </React.Suspense>
                </Container>
                <br />
            </Box>
        </Box>
    )
}

export default Dashboard;


